module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-18-f9428c35e78c0dd4688e337a6b8b739f.jpg";